import Form from "../components/form";
import Links from "../pages/hiddenpages/links";

const HiddenPage = ({ form, links }) => {
  return (
    <>
      <div className="hidden-page-container">
        {form && <Form formid={form} />}
        {links && <Links />}
      </div>
    </>
  );
};

export default HiddenPage;
